/**
 * Toda rota do WhatsApi é por tenant. Sem tenant a mutação recusa antes do HTTP,
 * em vez de mandar `/tenants/undefined/...` — 7 POST assim deram 422 em prd em
 * 16/10/2026, com o toast genérico "Falha ao criar API key".
 */
export function exigirTenant(tenantId: number | undefined | null): number {
  if (tenantId == null) throw new Error('Nenhum tenant disponível para esta operação')
  return tenantId
}
